export default __webpack_public_path__ + "static/media/chs.4c05dc41.png";